@if (scormProgressLoaded) {
  <app-iframe-fullscreen
    [url]="scormEmbedUrl"
    [enableDownload]="enableDownload"
    [enableFullscreen]="enableFullscreen"
    [isFileDownloading]="isDownloading"
    (fullscreenEnabled)="sendSuspendDataPostMessage()"
    (download)="downloadFile()">
  </app-iframe-fullscreen>
}
